import { useTranslation } from 'react-i18next';

interface Props {
    name: string;
    nameKo?: string;
    nameEn?: string;
    nameJa?: string;
}

/**
 * 각 언어별로 상품명을 달리 출력한다.
 * @param name
 * @param nameKo
 * @param nameEn
 * @param nameJa
 */
function useGlobalName({
    name, nameKo, nameEn, nameJa,
}:Props): string {
    const { i18n } = useTranslation();
    const { language } = i18n;
    const lang = language.split('-')[0];
    switch (lang) {
    case 'ko':
        return nameKo || name;
    case 'ja':
        return nameJa || name;
    case 'en':
        return nameEn || name;
    default:
        return name;
    }
}

export default useGlobalName;
